import "./AssignPurchasePriceModal.scss";

import AssignPurchasePriceModal from "./AssignPurchasePriceModal";

export default AssignPurchasePriceModal;